import { useEffect, useRef } from "react";

const ROW = 44;

export const TimeWheel = ({ options, value, onChange }) => {
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const i = options.indexOf(value);
    if (ref.current && i >= 0) ref.current.scrollTop = i * ROW;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onScroll = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      const i = Math.round(ref.current.scrollTop / ROW);
      const next = options[Math.min(Math.max(i, 0), options.length - 1)];
      if (next !== value) onChange(next);
    }, 80);
  };

  const pick = (i) => ref.current.scrollTo({ top: i * ROW, behavior: "smooth" });

  return (
    <div className="relative mx-auto w-full max-w-[220px]" data-testid="book-time-wheel">
      <div className="pointer-events-none absolute inset-x-0 top-1/2 z-10 h-11 -translate-y-1/2 rounded-xl border border-jade/40 bg-jade/5" />
      <div className="pointer-events-none absolute inset-x-0 top-0 z-10 h-16 bg-gradient-to-b from-white to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-16 bg-gradient-to-t from-white to-transparent" />
      <div
        ref={ref}
        onScroll={onScroll}
        className="h-[220px] snap-y snap-mandatory overflow-y-scroll [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        style={{ paddingTop: ROW * 2, paddingBottom: ROW * 2 }}
      >
        {options.map((t, i) => (
          <button
            type="button"
            key={t}
            data-testid={`book-slot-${t.replace(":", "")}`}
            onClick={() => pick(i)}
            className={`flex h-11 w-full snap-center items-center justify-center font-serif text-lg transition-colors duration-200 ${
              t === value ? "font-semibold text-jade" : "text-ink2/50"
            }`}
          >
            {t}
          </button>
        ))}
      </div>
    </div>
  );
};
